import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetAgreementTemplate,
  usePutAgreementTemplate,
} from 'services/templates/agreement-template';
import { IContractTemplateForm } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditAgreementTemplate = () => {
  const id = useParamId('/templates-extended');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const agreementTemplate = useGetAgreementTemplate(id);

  const updateAgreementTemplate = usePutAgreementTemplate(id);

  const goBackToAgreement = () =>
    navigate(`/templates-extended/agreement/${id}/form`);

  const name = agreementTemplate.data
    ? agreementTemplate.data?.title
    : undefined;

  const onUpdateAgreementTemplate = async (values: IContractTemplateForm) => {
    if (values.sideMenu?.detail) {
      return await updateAgreementTemplate.mutateAsync(
        middleware.template.agreement.formToQuery(
          values.sideMenu?.detail.content
        ),
        {
          onSuccess: goBackToAgreement,
          onError: error => onErrorShowAllErrorsToast(error),
        }
      );
    }
  };

  return (
    <Form.Contract
      tittle={`${t('button.edit')} ${
        name ?? t('contract-template.agreement.title')
      }`}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToAgreement}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t(`button.save`)} />
          </Button>
        </>
      }
      initialStatus={contractTemplateUtil.agreement.initialStatus}
      initialValues={
        agreementTemplate.data
          ? middleware.template.agreement.queryToForm(agreementTemplate.data)
          : contractTemplateUtil.agreement.initialValues()
      }
      onSubmit={onUpdateAgreementTemplate}
    />
  );
};

export default EditAgreementTemplate;
